import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Transforms } from '@app/shared';


@Component({
  selector: 'text-box',
  standalone: false,
  templateUrl: './text-box.component.html',
  styleUrl: './text-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextBoxComponent {
  public id = input.required<string>();
  public formGroup = input.required<FormGroup>();  
  public label = input.required<string>();
  public placeHolder = input<string>();
  public rows = input.required<string>();
  public maxLength = input<number>();
  public focus = input(false, {
    transform: Transforms.toBoolean
  });
  
  public readonly = input(false, {
    transform: Transforms.toBoolean
  });

  public required = input(false, {
    transform: Transforms.toBoolean
  });

  constructor() {}
}
